;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { safeStructuredClone } from './safe-structured-clone'

function assertIsNonNullObject(value: unknown): asserts value is object {
  if (typeof value !== 'object' || value === null) {
    throw new TypeError('Failed to clone error')
  }
}

/**
 * Clones an error and returns a new error with the same properties.
 *
 * Useful for logging redacted errors
 */
export function cloneError<TError extends Error>(error: TError) {
  const clonedError: unknown = Object.create(Object.getPrototypeOf(error))
  assertIsNonNullObject(clonedError)
  // Copy enumerable own properties (e.g., custom fields like `details`)
  for (const [key, value] of Object.entries(error)) {
    Reflect.set(clonedError, key, safeStructuredClone(value))
  }

  // Copy standard non-enumerable Error fields as own properties so errors
  // with getter-only fields (e.g. ZodError.message) can still be cloned.
  Object.defineProperty(clonedError, 'name', {
    value: error.name,
    writable: true,
    enumerable: false,
    configurable: true,
  })
  Object.defineProperty(clonedError, 'message', {
    value: error.message,
    writable: true,
    enumerable: false,
    configurable: true,
  })
  Object.defineProperty(clonedError, 'stack', {
    value: error.stack,
    writable: true,
    enumerable: false,
    configurable: true,
  })

  // Return type follows `error: TError`; clone preserves prototype (see clone-error.test.ts).
  // oxlint-disable-next-line typescript/consistent-type-assertions -- prototype contract is tested, not runtime-checkable via erased TError
  return clonedError as TError
}
